<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="520px"
    custom-class="lease-ylw-dialog"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div class="import-body">
      <el-button size="small" type="text" icon="el-icon-download" @click="downloadTemplate">
        下载导入模板
      </el-button>
      <el-upload
        ref="upload"
        drag
        action=""
        :auto-upload="false"
        :limit="1"
        accept=".xlsx,.xls"
        :on-change="onChange"
        :on-remove="onRemove"
        :file-list="fileList"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击选择</em></div>
        <div class="el-upload__tip" slot="tip">仅支持 .xlsx / .xls</div>
      </el-upload>
      <div v-if="resultText" class="result">{{ resultText }}</div>
    </div>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="submit">开始导入</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { leaseRequestError } from "@/service/fishPondLease.js";

export default {
  name: "ImportExcelDialog",
  props: {
    title: { type: String, default: "批量导入" },
    downloadFn: { type: Function, required: true },
    importFn: { type: Function, required: true }
  },
  data() {
    return {
      visible: false,
      loading: false,
      fileList: [],
      rawFile: null,
      resultText: ""
    };
  },
  methods: {
    open() {
      this.visible = true;
      this.fileList = [];
      this.rawFile = null;
      this.resultText = "";
    },
    handleClose() {
      this.fileList = [];
      this.rawFile = null;
    },
    onChange(file, fileList) {
      this.fileList = fileList.slice(-1);
      this.rawFile = file.raw;
    },
    onRemove() {
      this.fileList = [];
      this.rawFile = null;
    },
    async downloadTemplate() {
      try {
        await this.downloadFn();
      } catch (e) {
        this.$message.error(leaseRequestError(e) || "模板下载失败");
      }
    },
    async submit() {
      if (!this.rawFile) {
        this.$message.warning("请先选择 Excel 文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.rawFile);
      this.loading = true;
      try {
        const { data } = await this.importFn(formData);
        const success = (data && data.successCount) || 0;
        const fail = (data && data.failCount) || 0;
        const errors = (data && data.errors) || [];
        this.resultText = `导入完成：成功 ${success} 条，失败 ${fail} 条`;
        if (errors.length) {
          this.resultText +=
            "；详情：" +
            errors
              .slice(0, 5)
              .map(e => `第${e.row}行 ${e.message}`)
              .join("；");
          if (errors.length > 5) {
            this.resultText += `…（共 ${errors.length} 条错误）`;
          }
        }
        if (fail > 0 && success === 0) {
          this.$message.warning("导入失败，请查看明细");
        } else if (fail > 0) {
          this.$message.warning(`部分成功：成功 ${success}，失败 ${fail}`);
          this.$emit("success");
        } else {
          this.$message.success(`导入成功 ${success} 条`);
          this.visible = false;
          this.$emit("success");
        }
      } catch (e) {
        this.$message.error(leaseRequestError(e) || "导入失败");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.import-body {
  min-height: 180px;
}
.result {
  margin-top: 12px;
  color: #606266;
  font-size: 13px;
  line-height: 1.6;
  word-break: break-all;
}
</style>
